export async function initializeProductComparison() {
  const comparisonWrapper = document.getElementById('js-ad-tab-comparison');
  const comparisonTab = document.querySelector('.js_product_details_switch_button[data-content="js-ad-tab-comparison"]');

  if (comparisonWrapper && comparisonTab) {
    const loadingText = 'Lade die Daten...';
    comparisonWrapper.innerHTML = loadingText;

    comparisonTab.addEventListener('click', () => {
      if (comparisonWrapper.innerHTML === loadingText) {
        updateProductComparison(comparisonWrapper.dataset.articleGroupIds, false);
      }
    });
  } else {
    addInputEvents();
  }

  addOnlyDiffEvent();
}

/**
 * Hides or shows the elements that have no difference.
 *
 * @param {boolean} onlyDifference
 */
function changeDifferencesOnly(onlyDifference) {
  document.querySelectorAll('.js_no_difference').forEach(function(element) {
    if (onlyDifference && !element.classList.contains('hidden')) {
      element.classList.add('hidden');
    }
    if (!onlyDifference && element.classList.contains('hidden')) {
      element.classList.remove('hidden');
    }
  });
}

/**
 * Updates the product comparison with the given encoded articleGroupIds.
 * Shows a loading mask if showLoading is true.
 *
 * @param {string} articleGroupIds
 * @param {boolean} showLoading
 */
function updateProductComparison(articleGroupIds, showLoading = true) {
  let formData = new FormData();
  formData.append('articleGroupIds', articleGroupIds);

  const waitMask = document.getElementById('wait-mask');
  if (showLoading) {
    waitMask.style.display = 'block';
  }

  const csrfToken = fetchCsrfToken();

  // On the main page we redirect to the requested comparison page
  if (document.querySelector('.js_product_comparison_main_page')) {
    fetch('/productDataActionEndpoint.php?action=getComparisonUrl', {
      method: 'POST',
      body: formData,
      headers: {'X-CSRF-Token': csrfToken},
    }).then((res) => {
      res.json().then((data) => {
        if (data.data.url) {
          document.location.href = data.data.url;
        } else {
          document.querySelector('.js_product_comparison_main_page').innerHTML = 'Fehler beim Laden der Daten.';
          if (showLoading) {
            waitMask.style.display = 'none';
          }
        }
      });
    });

    return;
  }

  // On the PDP we only exchange the comparison content
  fetch('/productDataActionEndpoint.php?action=getComparisonHtml', {
    method: 'POST',
    body: formData,
    headers: {'X-CSRF-Token': csrfToken},
  }).then((res) => {
    if (showLoading) {
      waitMask.style.display = 'none';
    }
    res.json().then((data) => {
      const html = data.data.html;
      if (html) {
        document.getElementById('js-ad-tab-comparison').innerHTML = data.data.html;
        addInputEvents();
      } else {
        document.getElementById('js-ad-tab-comparison').innerHTML = 'Fehler beim Laden der Daten.';
      }
    });
  });
}

async function addInputEvents() {
  const selectedArticleGroupIds = getSelectedArticleGroupIds();
  document.querySelectorAll('.js_comparison_article_groups').forEach(function(comparisonArticleGroup) {
    $(comparisonArticleGroup).autocomplete({
      serviceUrl: '/findComparisonArticleGroups.php?groups=' + JSON.stringify(selectedArticleGroupIds),
      onSelect: function(suggestion) {
        selectArticleGroup(suggestion.artikel_gruppe_id, comparisonArticleGroup);
      },
      formatResult: function(suggestion, val) { return suggestion.value; },
      minChars: 0,
      deferRequestBy: 100,
      triggerSelectOnValidInput: false,
      containerClass: 'autocomplete-suggestions comparison-autocomplete-container',
    });

    comparisonArticleGroup.addEventListener('focus', function() {
      comparisonArticleGroup.select();
    });
  });

  addOnlyDiffEvent();
}

function selectArticleGroup(articleGroupId, comparisonArticleGroup) {
  comparisonArticleGroup.dataset.articleGroupId = articleGroupId;
  updateProductComparison(JSON.stringify(getSelectedArticleGroupIds()));
}

function getSelectedArticleGroupIds() {
  let articleGroupIds = [];
  document.querySelectorAll('.js_comparison_article_groups').forEach(function(comparisonArticleGroup) {
    articleGroupIds.push(comparisonArticleGroup.dataset.articleGroupId);
  });

  return articleGroupIds;
}

document.addEventListener('DOMContentLoaded', function() {
  initializeProductComparison();
});

function addOnlyDiffEvent() {
  const diffCheckbox = document.querySelector('.js_show_only_differences');
  if (diffCheckbox) {
    diffCheckbox.addEventListener('change', function() {
      changeDifferencesOnly(diffCheckbox.checked);
    });
  }
}